function setPriceIva() {
    let value = $('#batteries_model_list_price').val()
    if(!undefinedOrNull(value) && value !== ''){
        let price = parseInt(value)
        let iva = price * 0.16
        $('#batteries_model_list_price_iva').val(price + iva)
    }
}

function destroyBatteriesModel() {
    if(document.getElementById('batteries_model_form')) {
        $(document).off('change', '#batteries_model_list_price', setPriceIva)
        $('#add-tier-item').off('click');
        $('#tier-items-container').off('click');
        // $('#tier-items-container').off('change');
        // $('#tier-items-container').off('input');
    }
}

function setupBatteriesModel() {
    if(document.getElementById('batteries_model_form')) {
        $(document).on('change', '#batteries_model_list_price', setPriceIva)

        $('#add-tier-item').on('click', function(e){
            e.preventDefault();

            let uniqueId = new Date().getTime();
            let templateHtml = $('#tier-item-template').html();
            let newRowHtml = templateHtml.replace(/NEW_RECORD/g, uniqueId);

            let $newRow = $(newRowHtml);

            $newRow.find('.select2-container').remove();
            $newRow.find('select')
                .removeClass('select2-hidden-accessible')
                .removeAttr('data-select2-id aria-hidden tabindex id');
            $newRow.find('option').removeAttr('data-select2-id');

            $('#tier-items-container').append($newRow);

            $newRow.find('select').select2({
                width: '100%',
                theme: 'classic'
            });
        });

        $('#tier-items-container').on('click', '.remove-tier-item', function(e) {
            e.preventDefault();
            let row = $(this).closest('.tier-item-row');
            row.find('.destroy-flag').val('1');
            row.hide();
        });
    }
}

$(document).on('turbolinks:load', setupBatteriesModel)
window.addEventListener('beforeunload', (event) => {
    destroyBatteriesModel();
});